export default __webpack_public_path__ + "static/media/signpost-1.5844aa73.png";